<template>
    <transition name="pm-fade-in-slide-up-transition">
    <div v-if="visible" id="pm-welcome-dialog" style="display: block; z-index: 4;">
        <div id="pm-welcome-dialog-content" style="height: auto!important; min-height: auto!important; position: relative; font-size: 15px; display: block; padding: 20px 0px;">

                <div style="position: absolute; top: 0; right: 0; padding: 22px 12px 10px 10px;">
                <div @click="close" style="width: 28px; height: 28px; line-height: 22px; text-align: center; border: 2px solid #ddd; border-radius: 50%;" class="main-dialog--close">
                    <span style="font-weight: 600;"><v-icon style="font-size: 16px;">close</v-icon></span>
                </div>
                </div>

                <div style="padding: 0 20px; text-align: left;">

                    <h2 style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; max-width: 90%; line-height: 1.2; margin-top: 5px; margin-bottom: 14px; font-size: 16px; font-weight: 600; text-transform: uppercase;">
                        <template v-if="mode==='item'">{{ $t('plan_calculator.group_' + item.group) }}</template>
                        <template v-if="mode==='protocol'">{{ $t("plan_simple.template_"+item.title) }}</template>
                        <br/>
                        <small style="text-transform: none;">Option #{{idx+1}}</small>
                    </h2>

                    <v-text-field ref="input-title" type="text" v-model="title" :label="$t('settings.treatment_name')" />

                    <v-text-field @input="onPriceInput" ref="input-price" type="text" v-model="formattedUnitPrice" :label="mode === 'item' ? $t('settings.treatment_unit_price') : 'Package price'" />

                    <div class="beta-language-notification">
                        <div class="grey--text" style="text-align: left; font-size: 12px; border-radius: 7px; padding: 6px 0px; margin: 0 0 16px 0">
                            {{ $t('settings.only_numbers') }}<br/>Eg.: $9.99 &rarr; $10
                        </div>
                    </div>

                    <!-- <div v-if="mode==='item'" style="font-size: 12px; line-height: 1.4; color: rgb(170, 170, 170);">
                        {{$t(`protocol_descriptions.${['_','implant','bridge','temporary_bridge','_','_','one_phase_implants','veneer'][item.group]}`)}}
                    </div> -->

                    <!-- <div style="font-size: 12px; line-height: 1.4; color: #aaa;" v-if="mode==='protocol' && $te('protocol_descriptions.'+item.title) && $t('protocol_descriptions.'+item.title) !== ''" v-html="$t('protocol_descriptions.'+item.title)"></div> -->

                    <div style="margin: 14px 0; border-top: 1px solid rgba(0,0,0,.08);"></div>

                    <div style="display: flex; width: 100%;">
                        <div style="flex-grow: 1;">
                            <!-- <v-switch style="margin-top: 0;" /> -->
                        </div>
                        <v-btn style="margin: 0; border-radius: 16px;" large class="green" @click="save">
                            <span style="text-transform: uppercase!important; color: #fff;">
                                SAVE
                            </span>
                        </v-btn>
                    </div>

                </div>



        </div>
    </div>
    </transition>
</template>

<script>

import { formatPrice } from "../../utils/price-formatter"


export default {
    components: {

    },

    data: () => ({
        visible: false,
        title: "",
        price: "",
        idx: 1,
        item: {},
        formattedUnitPrice: "",
        mode: "item",
    }),

    created() {
        this.registerBusEvent('pricelist:edit-item', (params) => {
            this.mode = "item";
            this.edit(params);
        });

        this.registerBusEvent('pricelist:edit-protocol', (params) => {
            this.mode = "protocol";
            this.edit(params);
        });
    },

    methods: {
        onPriceInput() {
            this.$nextTick(()=> {
                if (this.formattedUnitPrice === "") return;
                if (this.formattedUnitPrice.length > 11) this.formattedUnitPrice = this.formattedUnitPrice.substring(0,11);
                this.formattedUnitPrice = formatPrice(this.formattedUnitPrice);
                if (this.formattedUnitPrice === "NaN") this.formattedUnitPrice = "";
            });
        },

        getPrice() {
            let price = this.price;

            if (typeof price === "undefined" || price === 0) {
                return 0;
            }
            price = formatPrice(price);
            return price;
        },

        edit(params) {
            console.log("params", params);
            const [ item, idx, el ] = params;
            this.item = item;
            this.idx = idx;

            if (this.mode === "item")  this.getItemData(item);
            if (this.mode === "protocol") this.getProtocolData(item);

            this.formattedUnitPrice = this.getPrice();
            this.visible = true;

            this.$nextTick(() => {
                this.$refs['input-'+el].focus();
            })
        },

        getItemData(item) {
            this.title = item.title[this.$store.state.language];
            this.price = item.price[this.$store.state.currency];
        },

        getProtocolData(item) {
            this.title = item.variation_titles[this.idx][this.$store.state.language];
            this.price = item.variation_prices[this.idx][this.$store.state.currency];
        },

        save() {
            const price = parseInt(String(this.formattedUnitPrice).replace(/([^0-9]+)/g, ""));
            if (this.mode === "item") {
                this.item.title[this.$store.state.language] = this.title;
                this.item.price[this.$store.state.currency] = isNaN(price) ? 0 : price;
            }
            if (this.mode === "protocol") {
                this.item.variation_titles[this.idx][this.$store.state.language] = this.title;
                this.item.variation_prices[this.idx][this.$store.state.currency] = isNaN(price) ? 0 : price;
            }
            this.$emit('save');
            this.close();
        },

        close() {
            this.visible = false;
        },
    }
};
</script>
